import { DateFilterModel } from 'ag-grid-community';
import { Injectable } from '@angular/core';
import { DateRangeFilter } from '@compumark/analyst-selection-tool-client';
import moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class FilterDateService {
  createDateFilter(dateFilter: DateFilterModel): DateRangeFilter | undefined {
    if (!(dateFilter?.dateFrom || dateFilter?.dateTo)) {
      return undefined;
    }

    let startDate: string | undefined = dateFilter?.dateFrom ?? undefined;
    let endDate: string | undefined = dateFilter?.dateTo ?? undefined;

    switch (dateFilter?.type) {
      case 'equals':
        endDate = startDate;
        break;
      case 'lessThan':
        endDate = startDate;
        startDate = undefined;
        break;
      case 'greaterThan':
        endDate = undefined;
        break;
    }

    return {
      startDate: this.formatDate(startDate),
      endDate: this.getNextWorkDayAt9(endDate),
    };
  }

  private formatDate(date?: string): string | undefined {
    if (!date) {
      return undefined;
    }
    const d = moment(date);
    return d.utc().format();
  }

  private getNextWorkDayAt9(date?: string): string | undefined {
    if (!date) {
      return undefined;
    }

    const d = moment(date);
    if (d.isoWeekday() === 5) {
      d.add(3, 'days');
    } else if (d.isoWeekday() === 6) {
      d.add(2, 'days');
    } else {
      d.add(1, 'days');
    }
    d.hour(9);
    return d.utc().format();
  }
}
